import { fetch } from "../services/api";
import useApi from "./useApi";
import { useContext } from "react";
import { HotelContext } from "../context/hotel";
import { CheckInContext } from "../context/checkin";

const usePaymentsActions = () => {
    const { get, post } = useApi();
    const { data: hotel } = useContext(HotelContext);
    const { data: checkin } = useContext(CheckInContext);

    const sessionInit = async (payload) => {
        try {
            const response = await post(`hotels/${hotel.id}/checkins/${checkin.id}/payments`, payload);
            return response || false;
        } catch (error) {
            console.error('Error fetching hotel by code:', error);
            return false;
        }
    };

    const event = async (id, event, payload) => {
        try {
            const response = await post(`hotels/${hotel.id}/checkins/${checkin.id}/payments/events`, {
                id,
                event,
                ...payload
            });
            return response || false;
        } catch (error) {
            console.error('Error fetching hotel by code:', error);
            return false;
        }
    };


    // const sendPayment = async () => {
    //     try {
    //         const response = await post(`test-payments`);
    //         return response || false;
    //     } catch (error) {
    //         console.error('Error fetching hotel by code:', error);
    //         return false;
    //     }
    // };

    // DEPRECATED por sessionInit
    const sendPayment = async (payload) => {
        try {
            const response = await post(`hotels/${hotel.id}/payments`, payload);
            return response || false;
        } catch (error) {
            console.error('Error fetching hotel by code:', error);
            return false;
        }
    };

    // DEPRECATED por event
    const paymentEvent = async (id, event, payload) => {
        try {
            const response = await post(`hotels/${hotel.id}/payment-event`, {
                id,
                event,
                ...payload
            });
            return response || false;
        } catch (error) {
            console.error('Error fetching hotel by code:', error);
            return false;
        }
    };

    const payAgain = async (requestId, paymentType) => {
        try {
            const response = await post(`hotels/${hotel.id}/public/requests/${requestId}/payments/${paymentType}`, {});
            return response || false;
        } catch (error) {
            console.error('Error paying again:', error);
            return false;
        }
    };

    const getPaymentMethods = async (requestId) => {
        try {
            const response = await post(`hotels/${hotel.id}/public/requests/${requestId}/payments`, {});
            return response || false;
        } catch (error) {
            console.error('Error paying:', error);
            return false;
        }
    };


    // const checkPayment = async (payload) => {
    //     try {
    //         const response = await post(`hotels/${data.id}/payment-check`, payload);
    //         return response || false;
    //     } catch (error) {
    //         console.error('Error fetching hotel by code:', error);
    //         return false;
    //     }
    // };


    return {
        sessionInit,
        event,
        payAgain,
        getPaymentMethods,
        sendPayment, // DEPRECATED
        paymentEvent // DEPRECATED
    }

}

export default usePaymentsActions;